import { JSX } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import TooltipWrapper from "@app/shared/TooltipWrapper";

export const NetworkIntegrityNotificationFlag = (props: {hasNetworkIntegrityFailure: boolean}): JSX.Element | null => {
  return (
      props.hasNetworkIntegrityFailure &&
    <span className="provider-hub__network-integrity-notification-flag">
        <TooltipWrapper
          delay={200}
          text="A Network Integrity issue has been identified."
          position="right"
        >
          <QesIcon iconName={QesIcons.FlagV1}width="14" description="focus or hover for a tooltip" />
        </TooltipWrapper>
      </span>
    );
}